import React from 'react';
import Dialog from '../../../core/layout/Dialog';
import Button from '../../../core/form/Button';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import DateInput from '../../../core/form/DateInput';
import get from 'lodash/get';
import { CURRENCY_MASK_OPTIONS } from '../../../core/consts';
import MaskInput from '../../../core/form/MaskInput';
import Alert from '../../../core/layout/Alert';
import Separator from '../../../core/layout/Separator';

const BillPaymentDialog = (props) => {
  return (
    <Dialog
      title={get(props.values, 'billId', null) ? `Bill ${get(props.values, 'billId', null)}` : 'Bills'}
      isOpen={props.isOpen}
      onCancel={props.onCancel}
      actions={[
        <Button label="Cancel" onClick={props.onCancel} loading={props.submitting} key="cancel" />,
        <Button label="Pay" icon="credit-card" onClick={props.onPay} loading={props.submitting} key="pay" />,
      ]}
    >
      <Alert description="This action cannot be undone. All values should be set as R$" type="warning" />
      <Separator />
      <Row>
        <Column size={4}>
          <DateInput
            disabled={props.submitting}
            label="Payment Date"
            required={true}
            value={get(props.values, 'paidAt', null)}
            onChange={(value) => props.onChange('paidAt', value)}
            errorText={get(props.errors, 'paidAt', '')}
          />
        </Column>
        <Column size={4}>
          <MaskInput
            disabled={props.submitting}
            label={`Paid value (R$)`}
            required={true}
            value={get(props.values, 'paidValue', null)}
            onChange={(value) => props.onChange('paidValue', value)}
            errorText={get(props.errors, 'paidValue', '')}
            delimiter={CURRENCY_MASK_OPTIONS.real.delimiter}
            numeralDecimalMark={CURRENCY_MASK_OPTIONS.real.numeralDecimalMark}
            maskType="numeral"
          />
        </Column>
        <Column size={4}>
          <MaskInput
            disabled={props.submitting}
            label={`Fines value (R$)`}
            value={get(props.values, 'finesValue', null)}
            onChange={(value) => props.onChange('finesValue', value)}
            errorText={get(props.errors, 'finesValue', '')}
            delimiter={CURRENCY_MASK_OPTIONS.real.delimiter}
            numeralDecimalMark={CURRENCY_MASK_OPTIONS.real.numeralDecimalMark}
            maskType="numeral"
          />
        </Column>
      </Row>
    </Dialog>
  );
};

BillPaymentDialog.propTypes = {
  isOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  onPay: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

BillPaymentDialog.defaultProps = {
  isOpen: false,
  submitting: false,
  errors: {},
};

export default BillPaymentDialog;
